import React from 'react';
import { App } from '../../../models/app';
import { useFetchServerFeaturesQuery } from '../../../redux/api/appMarket-api-slice';
import { ServerFeatures } from '../../../models/enums';
import { AppsAvailableOn } from './AppsAvailableOn';
import { FeaturedCollections } from './FeaturedCollections';
import { AppsVersion } from './AppsVersion';
import { SupportInformation } from './SupportInformation';

interface ComponentProps {
  app: App;
}

export const AppDetailsSideContent: React.FC<ComponentProps> = ({ app }): JSX.Element => {
  const { androidVersion, id } = app;
  const { data: deviceServerFeatures } = useFetchServerFeaturesQuery({
    features: [
      ServerFeatures.Flex,
      ServerFeatures.Station2018,
      ServerFeatures.StationSolo,
      ServerFeatures.Mini2,
      ServerFeatures.StationDuo,
      ServerFeatures.Flex2,
      ServerFeatures.Flex3,
      ServerFeatures.Mini3,
      ServerFeatures.StationSoloInternational,
      ServerFeatures.StationDuo2,
      ServerFeatures.KDS,
      ServerFeatures.FLEX4,
      ServerFeatures.FLEX4P,
      ServerFeatures.KDS_XL,
      ServerFeatures.KIOSK,
      ServerFeatures.COMPACT,
      ServerFeatures.COMPANION
    ],
  });

  return (
    <>
      <FeaturedCollections appId={id} />
      {androidVersion && <AppsVersion app={app} />}
      {deviceServerFeatures ? <AppsAvailableOn app={app} deviceServerFeatures={deviceServerFeatures} /> : null}
      <SupportInformation app={app} />
    </>
  );
};
